import { EmployeeModel } from '@libs/account/models';

const assignableRoles: EmployeeModel['assignableRoles'] = [
  {
    id: 1,
    name: 'Employee Admin',
    displayName: 'Mitarbeiterverwaltung',
    description: 'Can manage employee permissions',
    createdAt: '2026-06-01T00:00:00.000Z',
    delegation: 'user',
  },
  {
    id: 2,
    name: 'Order Viewer',
    displayName: 'Bestellungen ansehen',
    description: 'Can view order and pricing details',
    createdAt: '2026-06-01T00:00:00.000Z',
    delegation: 'none',
  },
];

export const employeesData: EmployeeModel[] = [
  {
    id: 'emp-1',
    customerId: 1001,
    userId: 2001,
    mainUser: true,
    email: 'john.doe@example.com',
    status: 'active',
    assignableRoles: [...assignableRoles],
    assignedRoles: [assignableRoles[0], assignableRoles[1]],
  },
  {
    id: 'emp-2',
    customerId: 1001,
    userId: 2002,
    mainUser: false,
    email: 'max.mustermann@example.com',
    status: 'active',
    assignableRoles: [...assignableRoles],
    assignedRoles: [assignableRoles[1]],
  },
  {
    id: 'emp-3',
    customerId: 1001,
    mainUser: false,
    email: 'chuck.norris@example.com',
    status: 'pending',
    assignableRoles: [...assignableRoles],
    assignedRoles: [],
  },
  {
    id: 'emp-4',
    customerId: 1001,
    mainUser: false,
    email: 'hannah.musterfrau@example.com',
    status: 'active',
    assignableRoles: [...assignableRoles],
    assignedRoles: [assignableRoles[1]],
  },
  {
    id: 'emp-5',
    customerId: 1001,
    mainUser: false,
    email: 'elmo.mueller@example.com',
    status: 'expired',
    assignableRoles: [...assignableRoles],
    assignedRoles: [],
  },
  {
    id: 'emp-6',
    customerId: 1001,
    mainUser: false,
    email: 'natalie.krajcik@example.com',
    status: 'active',
    assignableRoles: [...assignableRoles],
    assignedRoles: [assignableRoles[0]],
  },
  {
    id: 'emp-7',
    customerId: 1001,
    mainUser: false,
    email: 'beaulah.prohaska@example.com',
    status: 'active',
    assignableRoles: [...assignableRoles],
    assignedRoles: [assignableRoles[1]],
  },
  {
    id: 'emp-8',
    customerId: 1001,
    mainUser: false,
    email: 'gustave.tromp@example.com',
    status: 'pending',
    assignableRoles: [...assignableRoles],
    assignedRoles: [],
  },
  {
    id: 'emp-9',
    customerId: 1001,
    mainUser: false,
    email: 'winfield.crist@example.com',
    status: 'active',
    assignableRoles: [...assignableRoles],
    assignedRoles: [assignableRoles[1]],
  },
  {
    id: 'emp-10',
    customerId: 1001,
    mainUser: false,
    email: 'velda.harris@example.com',
    status: 'active',
    assignableRoles: [...assignableRoles],
    assignedRoles: [assignableRoles[1]],
  },
  {
    id: 'emp-11',
    customerId: 1001,
    mainUser: false,
    email: 'brooklyn.bernier@example.com',
    status: 'pending',
    assignableRoles: [...assignableRoles],
    assignedRoles: [],
  },
  {
    id: 'emp-12',
    customerId: 1001,
    mainUser: false,
    email: 'brandt.kunze@example.com',
    status: 'active',
    assignableRoles: [...assignableRoles],
    assignedRoles: [assignableRoles[1]],
  },
];
